module.exports = __webpack_public_path__ + "img/c02_unittrireme_Normal_ua.9b6bcc9c.webp";